import "@fontsource/geist-mono/400.css";
import "@fontsource/geist-mono/500.css";
import "@fontsource/geist-sans/400.css";
import "@fontsource/geist-sans/500.css";
import "@fontsource/geist-sans/600.css";
import "@fontsource/geist-sans/700.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./App";
import { AuthGate } from "./auth/AuthGate";
import { ReauthGate } from "./auth/ReauthGate";
import { SessionProvider } from "./auth/session";
import { TooltipProvider } from "./components/Tooltip";
import { CurrentWorkspaceProvider } from "./data/api/currentWorkspace";
import { PreferencesProvider } from "./data/api/preferences";
import "./theme/globals.css";
import "./theme/tokens.css";

const container = document.getElementById("root");
if (container) {
  createRoot(container).render(
    <StrictMode>
      {/* AuthGate sits inside the router so it can let the public /join
          enrollment route through unauthenticated (see AuthGate). */}
      <SessionProvider>
        <BrowserRouter>
          <AuthGate>
            <PreferencesProvider>
              <CurrentWorkspaceProvider>
                <TooltipProvider delayDuration={300}>
                  <App />
                  <ReauthGate />
                </TooltipProvider>
              </CurrentWorkspaceProvider>
            </PreferencesProvider>
          </AuthGate>
        </BrowserRouter>
      </SessionProvider>
    </StrictMode>,
  );
}
